import { createMachine, assign, spawn } from 'xstate';

import { createComponentMachine } from '../component';
import { ComponentModel } from '../../models';

import { ComponentsContext, ComponentsEvents } from './types';

export const createComponentsMachine = (subscriptionId: number) =>
  createMachine<ComponentsContext, ComponentsEvents>({
    initial: 'idle',
    predictableActionArguments: true,
    context: {
      subscriptionId,
      items: [],
    },
    states: {
      idle: {
        on: {
          FETCH_COMPONENTS: {
            target: 'loading',
          },
        },
      },
      ready: {
        on: {
          UPDATE_COMPONENTS: {
            target: 'loading',
          },
        },
      },
      error: {},
      loading: {
        invoke: {
          src: 'getComponents',
          onDone: {
            target: 'ready',
            actions: assign((_ctx, event) => {
              const components = event.data.items.map(
                (item: ComponentModel) => ({
                  component: item,
                  ref: spawn(createComponentMachine(item)),
                })
              );

              return {
                items: components,
              };
            }),
          },
          onError: {
            target: 'error',
          },
        },
      },
    },
  });
